export const viewModeStates = {
    VIEWING: 'viewing',
    EDITING: 'editing',
    SAVING: 'saving'
}